var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pz_card"},[_c('div',{staticClass:"img-container"},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.thumbPassed,"alt":"Default"}})]),_c('div',[_vm._v(_vm._s(_vm.seriesPassed))])])
}
var staticRenderFns = []

export { render, staticRenderFns }